import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EncryptionService } from '../services/EncryptionService/encryption-service.service';
import { catchError, map, of } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { ROUTES } from '@app/pages/routes';

export const PKeyGuard: CanActivateFn = () => {
  const encS: EncryptionService = inject(EncryptionService);
  const load: LoadingService = inject(LoadingService);
  const router: Router = inject(Router);

  // Verificar si es un refresh
  const isRefreshing = sessionStorage.getItem('isRefreshing') === 'true';
  if (isRefreshing) {
    // Limpiar el estado
    localStorage.clear();
    sessionStorage.clear();
    
    // Redirigir a welcome
    window.location.replace(router.serializeUrl(
      router.createUrlTree([ROUTES.WELCOME])
    ));
    return of(false);
  }

  return encS.getInitData().pipe(
    map((isApproved: boolean) => {
      if (isApproved) return true;
      router.navigate(['']);
      load.reset();
      return false;     
    }),
    catchError(error => {
      console.error('Error al obtener la llave:', error);
      router.navigate(['']);
      load.reset();
      return of(false);
    })
  );
};
